import React from "react";
import { Text } from "@salestrak/ui";
import { useOptionalActivityContext } from "../activity-context";
import type { ActivityChange } from "../activity-types";
import { countOf, pluralize } from "#app/lib/utils/pluralize";

export function AttachmentsLink({ ids, label }: { ids: readonly string[]; label: string }) {
  const openAttachments = useOptionalActivityContext()?.openAttachments;
  const text = countOf(ids.length, "photo");
  if (!openAttachments) return <>{text}</>;
  return (
    <Text size="sm" weight="medium" hoverInk className="cursor-pointer" onClick={() => openAttachments({ label, ids })}>
      {text}
    </Text>
  );
}

export function AttachmentsChunk({ change }: { change: ActivityChange }) {
  const ids: string[] = Array.isArray(change.newValue) ? change.newValue : [];
  return (
    <Text size="sm">
      uploaded {ids.length} {pluralize("file", { count: ids.length })}
    </Text>
  );
}
